import { Fragment } from "react";

function AffiliateBenefits() {
  return (
    <Fragment>
      <section className="shield-section">
        <div className="affiliate-benefits-grid">
          <h2 className="white-heading">Why affiliates choose Plaintr</h2>
          <div className="classic-cards-container">
            <div className="affiliate-benefit-card">
              <div className="affiliate-benefit-card-heading">
                <img
                  src="/images/icons/redeem_light_blue.svg"
                  alt="Start Creating your Plaintr Account, Apply and get approved"
                ></img>
                COMMISIONS
              </div>
              <div className="affiliate-benefit-card-content">
                <p>This isn’t a one-time payout or a small referral bonus.</p>
                <p>
                  With Plaintr, you earn as your network takes real action —
                  meaning your income grows as people actually use the services
                  you recommend.
                </p>
                <p>
                  You’re not chasing clicks. You’re building a revenue stream
                  tied to real financial outcomes.
                </p>
                <ul className="classic-list" style={{ marginTop: "10px" }}>
                  <li className="classic-list-item">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/verified_blue_badget.svg`}
                      alt=""
                      className="hero-list-icon"
                    />
                    <span>
                      Earn every time someone in your network completes a
                      service through your link
                    </span>
                  </li>
                  <li className="classic-list-item">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/verified_blue_badget.svg`}
                      alt=""
                      className="hero-list-icon"
                    />
                    <span>
                      Turn a single post, video, or recommendation into ongoing
                      income
                    </span>
                  </li>
                  <li className="classic-list-item">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/verified_blue_badget.svg`}
                      alt=""
                      className="hero-list-icon"
                    />
                    <span>
                      Build momentum — the more your network grows, the more
                      your earnings follow
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="affiliate-benefit-card">
              <div className="affiliate-benefit-card-heading">
                <img
                  src="/images/icons/support_light_blue.svg"
                  alt="Start Creating your Plaintr Account, Apply and get approved"
                ></img>
                Support and transparency
              </div>
              <div className="affiliate-benefit-card-content">
                <p>You’re not guessing what’s working.</p>
                <p>
                  Plaintr gives you full visibility into your performance — so
                  you can see what’s driving results, what’s converting, and how
                  your earnings are growing.
                </p>
                <p>
                  Everything is structured to help you improve, not just
                  participate.
                </p>

                <ul className="classic-list" style={{ marginTop: "10px" }}>
                  <li className="classic-list-item">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/verified_blue_badget.svg`}
                      alt=""
                      className="hero-list-icon"
                    />
                    <span>
                      Track your clicks, conversions, and earnings in one clear
                      dashboard
                    </span>
                  </li>
                  <li className="classic-list-item">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/verified_blue_badget.svg`}
                      alt=""
                      className="hero-list-icon"
                    />
                    <span>
                      See exactly how your content and links are performing
                    </span>
                  </li>
                  <li className="classic-list-item">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/verified_blue_badget.svg`}
                      alt=""
                      className="hero-list-icon"
                    />
                    <span>
                      Access support and guidance to help you improve and scale
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="affiliate-benefit-card">
              <div className="affiliate-benefit-card-heading">
                <img
                  src="/images/icons/loyalty_light_blue.svg"
                  alt="Start Creating your Plaintr Account, Apply and get approved"
                ></img>
                Scalable growth
              </div>
              <div className="affiliate-benefit-card-content">
                <p>This isn’t just about a single referral.</p>
                <p>
                  As Plaintr expands its services, your earning potential grows
                  with it — allowing you to build income from your existing
                  network over time.
                </p>
                <p>
                  The more your audience engages across the platform, the more
                  your results compound.
                </p>

                <ul className="classic-list" style={{ marginTop: "10px" }}>
                  <li className="classic-list-item">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/verified_blue_badget.svg`}
                      alt=""
                      className="hero-list-icon"
                    />
                    <span>
                      Benefit from a growing ecosystem of financial services
                    </span>
                  </li>
                  <li className="classic-list-item">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/verified_blue_badget.svg`}
                      alt=""
                      className="hero-list-icon"
                    />
                    <span>
                      Turn your influence into a long-term income stream
                    </span>
                  </li>
                  <li className="classic-list-item">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icons/verified_blue_badget.svg`}
                      alt=""
                      className="hero-list-icon"
                    />
                    <span>
                      Scale your earnings as your network engages more deeply
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
}

export default AffiliateBenefits;
